module.exports = __webpack_public_path__ + "static/media/Viva_Color.a381be78.png";